import { render, staticRenderFns } from "./VindiPlans.vue?vue&type=template&id=7db28bc2"
import script from "./VindiPlans.vue?vue&type=script&lang=js"
export * from "./VindiPlans.vue?vue&type=script&lang=js"
import style0 from "./VindiPlans.vue?vue&type=style&index=0&id=7db28bc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports